// extracted by mini-css-extract-plugin
module.exports = {"title":"DealsCreate_title__1NdxY"};